module.exports = __webpack_public_path__ + "img/hospital-ward-thumb.50221628.jpg";